var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "uploader",
    class: {
      'uploader_is-hovered-by-dragging': _vm.isHoveredByDragging,
      'uploader_disabled': _vm.disabled
    },
    on: {
      "dragenter": _vm.onDragenter,
      "dragleave": _vm.onDragleave
    }
  }, [_c('input', {
    staticClass: "uploader__file",
    attrs: {
      "id": _vm.id,
      "type": "file",
      "accept": _vm.accept,
      "title": _vm.fileNames,
      "multiple": _vm.isMultiple,
      "disabled": _vm.disabled
    },
    on: {
      "input": _vm.onInput
    }
  }), _c(_vm.iconComponent, {
    tag: "component",
    staticClass: "uploader__icon"
  }), _c('label', {
    staticClass: "uploader__label",
    attrs: {
      "for": _vm.id
    }
  }, [_vm.fileNames ? [_vm._v(" " + _vm._s(_vm.fileNames) + " ")] : _vm._t("default", function () {
    return [_vm._v(" Drop your file" + _vm._s(_vm.isMultiple ? 's' : '') + " here or "), _c('span', {
      staticClass: "uploader__label-highlighter"
    }, [_vm._v("click to upload")])];
  })], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }